import classNames from 'classnames/bind';
import React from 'react';

import styles from './SubnetOption.css';

const css = classNames.bind(styles);

type SubnetOption = {
    name: string;
    description?: React.ReactNode;
    onClick?(event: React.MouseEvent): void;
};

export const SubnetOption = ({ name, description, onClick }: SubnetOption) => (
    <div onClick={onClick} style={{ pointerEvents: 'auto', width: '100%' }}>
        {name} <div className={css('description')}>{description}</div>
    </div>
);
